// ============================================================
// ACTRA — CENTRALIZED PROTOCOL CONFIGURATION
// Single source of truth. All pages and components MUST read
// from here. Never duplicate these values elsewhere.
// ============================================================

export const PROJECT_NAME = "ACTRA";
export const PROJECT_SUBTITLE = "ACTION VERIFICATION NETWORK";
export const TAGLINE = "VERIFY EVERY ACTION.";
export const PROJECT_STATUS = "PRE-LAUNCH";

// ARC NETWORK
export const CHAIN_NAME = "Arc";
export const NETWORK_NAME = "ARC MAINNET";
export const CHAIN_ID = 5042;
export const CHAIN_ID_HEX = "0x13B2";
export const NATIVE_ASSET = "USDC";
export const EVM_COMPATIBLE = true;
export const NETWORK_FINALITY = "INSTANT";

// TOKEN CONTRACT — live on Arc Mainnet. Update this ONE value if it ever changes.
export const ACTRA_CONTRACT_ADDRESS = "0xeFCB9E628F828660774001e9B94A709Bf82A0087";
export const CONTRACT_MESSAGE = "ACTRA contract is live on Arc Mainnet (chain 5042).";

// EXTERNAL LINKS — official launch URLs.
export const BUY_URL = "https://lift.fun/token/0xeFCB9E628F828660774001e9B94A709Bf82A0087";
export const BUY_URL_LABEL = "LIFT.FUN";
export const CHART_URL = "https://dexscreener.com/arc/0x63886cd8c5833949686c2d3f5aa8e358e2d4017146b0b1bb1be041201526f83a";
export const CHART_URL_LABEL = "DEXSCREENER";
export const X_URL = "https://x.com/ActraFlow";
export const X_URL_LABEL = "X";
export const EXPLORER_URL = "https://explorer.arc.io";
export const CONTRACT_SHORT = ACTRA_CONTRACT_ADDRESS
    ? `${ACTRA_CONTRACT_ADDRESS.slice(0, 6)}…${ACTRA_CONTRACT_ADDRESS.slice(-4)}`
    : null;
export const EXPLORER_ADDRESS_URL =
    EXPLORER_URL && ACTRA_CONTRACT_ADDRESS ? `${EXPLORER_URL}/address/${ACTRA_CONTRACT_ADDRESS}` : null;
export const ARC_RPC_URL = process.env.REACT_APP_ARC_RPC_URL || "";

export const ACTRA_CONFIG = {
    PROJECT_NAME,
    PROJECT_SUBTITLE,
    TAGLINE,
    PROJECT_STATUS,
    CHAIN_NAME,
    NETWORK_NAME,
    CHAIN_ID,
    CHAIN_ID_HEX,
    NATIVE_ASSET,
    EVM_COMPATIBLE,
    NETWORK_FINALITY,
    ACTRA_CONTRACT_ADDRESS,
    CONTRACT_MESSAGE,
    BUY_URL,
    BUY_URL_LABEL,
    CHART_URL,
    CHART_URL_LABEL,
    X_URL,
    X_URL_LABEL,
    EXPLORER_URL,
};
